module.exports = __webpack_public_path__ + "media/scan_ok.3a3d479f.mp3";